import { render } from "./NewClaimDetailForm.vue?vue&type=template&id=c3f6c336&scoped=true&ts=true"
import script from "./NewClaimDetailForm.vue?vue&type=script&lang=ts"
export * from "./NewClaimDetailForm.vue?vue&type=script&lang=ts"

import "./NewClaimDetailForm.vue?vue&type=style&index=0&id=c3f6c336&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.9.3__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3f6c336"]])

export default __exports__